import Image from 'next/image';
import AnimatedBrandSymbol from '@/components/AnimatedBrandSymbol';

export default function BrandLockup({
  alt = 'BotGo',
  animated = false,
  className = '',
  hoverExpression = 'focus',
  priority = false,
  size = 40,
  suffix = '',
}) {
  const suffixSize = Math.round(size * 0.6);

  return (
    <span className={`inline-flex shrink-0 items-center ${className}`}>
      <span className="inline-flex shrink-0 items-center" style={{ gap: `${size / 10}px` }}>
        <AnimatedBrandSymbol
          animated={animated}
          compact
          decorative
          hoverExpression={hoverExpression}
          size={size}
        />
        <Image
          src="/brand/botgo-wordmark-white.svg"
          alt={alt}
          width={Math.round(size * 70 / 40)}
          height={size}
          priority={priority}
          className="h-auto shrink-0"
        />
      </span>
      {suffix ? (
        <span
          className="font-playfair font-semibold leading-none tracking-[-0.035em] text-white"
          style={{ fontSize: `${suffixSize}px` }}
        >
          {suffix}
        </span>
      ) : null}
    </span>
  );
}
